// Standard YAML's Failsafe schema.
// http://www.yaml.org/spec/1.2/spec.html#id2802346


'use strict';


var Schema = require('../schema');


module.exports = new Schema({
  explicit: [
    require('../type/str'),
    require('../type/seq'),
    require('../type/map')
  ]
});



/*****************
 ** WEBPACK FOOTER
 ** ./~/js-yaml/lib/js-yaml/schema/failsafe.js
 ** module id = 211
 ** module chunks = 0
 **/